import React, {useState} from 'react';
import ButtonComp from '../components/button'
import '../styling/containerStyles.css'
import DropDown from '../components/dropDown'
import Label from '../components/label'


interface QuestionDetailsProps{
    handleContractorType:Function;
}

export const QuestionDetails: React.FC<QuestionDetailsProps> = (props: QuestionDetailsProps) =>{

    const{
        handleContractorType
    } = props;
    
    const [profession, setProfession] = useState('Select')
    const [message, setMessage] = useState('')

    
    const handleToUpdateProfession = (arg: string) => {
        setProfession(arg)
    }
    

    const handleToUpdateAdd = (arg: string) => {

        const data = {
            "profession": profession
        }
        
        if(profession === 'Select' || profession === ""){
            setMessage('Please choose a valid option ')
            setProfession('')
        }
        else
            handleContractorType(data)
    }
    
        let dropDownItems = [];
        dropDownItems = ['Select', 'Contractor', 'Dealer'];
        
        return (
            <div className='custDetails' >
                <Label content='Are you a Dealer or a Contractor?' />
                    <DropDown item={dropDownItems} 
                            name='profession'
                            label='' 
                            handleToUpdate={handleToUpdateProfession}/>

                    <div className='message'>{message}</div>
                    
                    <ButtonComp label= {'Pin Code'} 
                            name={'Submit'} 
                            visible={true}
                            handleToUpdate={handleToUpdateAdd}  />
            </div>             
        )
    }


export default QuestionDetails